import axios from "axios";
import {RepositoryFactory} from "../../scripts/RepositoryFactory";

axios.defaults.withCredentials = false;
const ServiceRepository = RepositoryFactory.get('services');

const state = {
    baseDomain_live: "https://static.emsservice.de/teasertemplates/",
    baseDomain_stage: "https://static.emsservice.de/teasertemplates/stage/",
    baseDomain_live_cache: process.env.NODE_ENV === "development" ? 'http://localhost:3000/api/cache/' : process.env.VUE_APP_JSON_EDITOR_URL + "/api/cache/",
    baseDomain_stage_cache: process.env.NODE_ENV === "development" ? 'http://localhost:3000/api/preview/' : process.env.VUE_APP_JSON_EDITOR_URL + "/api/preview/",
    selectedPublisher: [],
    selectedSite: null,
    selectedSitetype: null,
    selectedEntry: null,
    siteDetails: null,
    jsonContent_live: null,
    jsonContent_stage: null,
    loadingSite: false,
    loadingJSON: false,
    finalTemplateKey: null, //key that the template is going to be saved with
    finalJson: null, //final jsonContent to saved
    types: [
        {name: 'Default', value: 'default'},
        {name: 'Homepage', value: 'homepage'},
        {name: 'Index', value: 'index'},
        {name: 'Bildergalerie', value: 'biga'},
        {name: 'Artikel', value: 'article'},
    ],
    teasertypes: [
        {name: 'Presenter', value: '_Presenter'},
        {name: 'Anzeige', value: '_Anzeige'},
        {name: 'Video', value: '_video'},
        {name: 'Outbrain', value: '_outbrain'},
    ]
}
const getters = {}
const actions = {
    async fetchSiteDetails({state, commit}, payload) { //SiteId
        state.loadingSite = true;
        try {
            let {data} = await ServiceRepository.getSiteDetails(payload.siteId)
            if (data.Status && (typeof payload.noCommit === "undefined" || !payload.noCommit)) {
                commit('setSiteDetails', data);
            }
            state.loadingSite = false;
            return data;

        } catch (e) {
            state.loadingSite = false;
        }
    },
    async fetchJSON({state, commit}, payload) { //sitetypeId
        state.loadingJSON = true;
        let sitetypeId = typeof payload === 'object' ? payload.id : payload;
        if (typeof payload !== 'object' && !payload.return) {
            state.jsonContent_live = null;
            state.jsonContent_stage = null;
        }
        let promises = [
            axios.get(`${state.baseDomain_live_cache}${sitetypeId}?_=${new Date().getTime()}`, {headers: {'X-API-KEY': process.env.VUE_APP_X_API_KEY}}),     // live_cached
            axios.get(`${state.baseDomain_live}${sitetypeId}.json?_=${new Date().getTime()}`),      // live
            axios.get(`${state.baseDomain_stage_cache}${sitetypeId}?_=${new Date().getTime()}`, {headers: {'X-API-KEY': process.env.VUE_APP_X_API_KEY}}),    // stage_cached
            axios.get(`${state.baseDomain_stage}${sitetypeId}.json?_=${new Date().getTime()}`),     // stage
        ];

        const [liveCacheRes, liveRes, stageCacheRes, stageRes] = await Promise.all(
            promises.map(request => request.catch(error => error))
        );

        state.loadingJSON = false;

        if (typeof payload === 'object' && payload.return) {
            return [liveCacheRes, liveRes, stageRes, stageCacheRes];
        }

        const isSuccess = (result) => result && !result.isAxiosError;
        const getData = (result) => (isSuccess(result) ? result.data : null)
        // Priorität:
        // live: erst cache/api, sonst S3
        // stage: erst preview/api, sonst S3
        const liveData = getData(liveCacheRes) ?? getData(liveRes) ?? {};
        const stageData = getData(stageCacheRes) ?? getData(stageRes) ?? {};

        commit('setJSON', {type: 'live', payload: liveData});
        commit('setJSON', {type: 'stage', payload: stageData});

        if (liveRes?.isAxiosError || stageRes?.isAxiosError) {
            return liveRes?.isAxiosError ? liveRes : stageRes;
        }
    }
}

const mutations = {
    setSiteDetails(state, data) {
        state.siteDetails = data;
    },
    setSite(state, data) {
        state.selectedSite = data;
    },
    setSitetype(state, data) {
        state.selectedSitetype = data;
    },
    setJSON(state, data) {
        state['jsonContent_' + data.type] = data.payload;
    },
    setSelectedEntry(state, data) {
        state.selectedEntry = data;
    },
    setFinalTemplateKey(state, data) {
        state.finalTemplateKey = data;
    },
    setFinalJson(state, data) {
        state.finalJson = data;
    },
    updateSelectedPublisher(state, {data}) {
        state.selectedPublisher = data;
    }
}


export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}